var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mangerDocuments bg-white px-8" },
    [
      _c("SearchableDocumentsList", {
        staticClass: "pb-5",
        attrs: {
          userFullName: _vm.managerFullName,
          query: _vm.query,
          currentUser: _vm.currentUser,
          extraInfoHidden: "",
        },
        on: { documentNumberChanged: _vm.handleDocumentNumberChanged },
        scopedSlots: _vm._u([
          {
            key: "emptyListActions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end pt-3 pb-5",
                  attrs: {
                    attachedToUserId: _vm.managerUserId,
                    companyId: _vm.companyId,
                    buttonLabel: "Upload document",
                    currentUserId: _vm.currentUser.id,
                    buttonSize: "xl",
                    showLabel: true,
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end",
                  attrs: {
                    attachedToUserId: _vm.managerUserId,
                    companyId: _vm.companyId,
                    buttonLabel: "Upload document",
                    currentUserId: _vm.currentUser.id,
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }